export const VIDEO_START_STP = [
  "anuragakms@gmail.com",
  "sanskardrolia@gmail.com",
  "nitesh@cipherschools.com",
  "geetika@cipherschools.com",
  "aman.cipherschools@gmail.com",
  "vishal.singh@cipherschools.com",
  "geetika.cipherschools@gmail.com",
];
